import { RejectReportModalComponent } from './reject-report-modal/reject-report-modal.component';

export const dialogs: any[] = [RejectReportModalComponent];

export * from './reject-report-modal/reject-report-modal.component';
